export enum UserDataActionType {
  // fetchAllUserData()
  FETCH_ALL_USER_DATA_COMMAND = 'pubnub/FETCH_ALL_USER_DATA_COMMAND',
  FETCHING_ALL_USER_DATA = 'pubnub/FETCHING_ALL_USER_DATA',
  ALL_USER_DATA_RETRIEVED = 'pubnub/ALL_USER_DATA_RETRIEVED',
  ERROR_FETCHING_ALL_USER_DATA = 'pubnub/ERROR_FETCHING_ALL_USER_DATA',
  // fetchUserData()
  FETCH_USER_DATA_COMMAND = 'pubnub/FETCH_USER_DATA_COMMAND',
  FETCHING_USER_DATA = 'pubnub/FETCHING_USER_DATA',
  USER_DATA_RETRIEVED = 'pubnub/USER_DATA_RETRIEVED',
  ERROR_FETCHING_USER_DATA = 'pubnub/ERROR_FETCHING_USER_DATA',
  // setUserData()
  SET_USER_DATA_COMMAND = 'pubnub/SET_USER_DATA_COMMAND',
  SETTING_USER_DATA = 'pubnub/SETTING_USER_DATA',
  USER_DATA_SET = 'pubnub/USER_DATA_SET',
  ERROR_SETTING_USER_DATA = 'pubnub/ERROR_SETTING_USER_DATA',
  // removeUserData()
  REMOVE_USER_DATA_COMMAND = 'pubnub/REMOVE_USER_DATA_COMMAND',
  REMOVING_USER_DATA = 'pubnub/REMOVING_USER_DATA',
  USER_DATA_REMOVED = 'pubnub/USER_DATA_REMOVED',
  ERROR_REMOVING_USER_DATA = 'pubnub/ERROR_REMOVING_USER_DATA',
  // objects events
  USER_DATA_SET_EVENT = 'pubnub/USER_DATA_SET_EVENT',
  USER_DATA_REMOVED_EVENT = 'pubnub/USER_DATA_REMOVED_EVENT',
}
